import { createBrowserHistory } from 'history';

import { normalizeLocationPath } from '../utility/trailingPunctuation';

// Clean up links that arrived with the sentence's punctuation glued on
// (`/donation/CAF2.`) before the history object reads the current location.
normalizeLocationPath();

export default createBrowserHistory();
